<template>

  <ob-dialog :heading="$t('issues.new')" @ok="ok()" @cancel="close()">
    <issue-codes-select v-model="values.code"></issue-codes-select>

    <v-textarea v-model="values.name"
                :label="$t('issues.description')"
                :rows="5"
                auto-grow
                data-test="issue-description"
    ></v-textarea>
  </ob-dialog>

</template>

<script>

import ObDialog from '../shared/components/dialog'
import IssueCodesSelect from '../issue-codes/components/issue-codes-select'

export default {
  name: 'issue-dialog',

  //props: [ 'element' ],

  data () {
    return {
      values: {}
    }
  },

  computed: {

  },

  methods: {
    ok () {
      this.$emit('submit', this.values)
    },

    close () {
      this.$emit('submit', false)
    }
  },

  mounted () {
    //this.values = Object.assign({}, this.element)
  },

  components: {
    IssueCodesSelect,
    ObDialog,
  }
}

</script>

<style lang="scss" scoped>

</style>
